export const brokerClientStatuses = {
    pending: 0,
    expiringSoon: 1,
    active: 2,
    expired: 3,
    rejected: 4,
};
